// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__230AE","head":"Table_head__1fH-5","col":"Table_col__2Scut"};